import { Component, OnInit, Renderer2, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  @Input() isDesktop = false;
  @ViewChild('myButton') buttonRef!: ElementRef<HTMLButtonElement>;
  @ViewChild('ok') okRef!: ElementRef<HTMLButtonElement>;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    this.loadAdScript();
  }

  loadAdScript(): void {
    const script = this.renderer.createElement('script');
    script.src = 'https://adcdn.nightlife.net/afe755b2.js';
    script.async = true;
    this.renderer.appendChild(document.body, script);
  }

  onClick(): void {
    const button = this.buttonRef.nativeElement;
    button.disabled = true;
    button.style.pointerEvents = 'none';
    this.okRef.nativeElement.style.zIndex = '0';
    setTimeout(() => {
      button.disabled = false;
      button.style.pointerEvents = 'auto';
      this.okRef.nativeElement.style.zIndex = '-1';
    }, 5000);

  }
}
